import { css } from '@emotion/react';

export const filterStyles = {
    root: css({
        border: '1px solid #DAE7FA',
        borderRadius: '8px',
        padding: '10px 15px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',
    }),
    topBlock: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),
    headerWrapper: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    title: css({
        fontSize: '15px',
        fontWeight: '700',
        color: '#000',
        marginBottom: '5px',
    }),
    chevronIcon: css({
        transform: 'rotate(90deg)',
        transition: 'transform 0.3s ease-in-out',
    }),
    chevronIconOpen: css({
        transform: 'rotate(-90deg)',
    }),
    contentWrapper: css({
        padding: '10px 0',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),
    radioInput: css({
        color: '#000000',
        fontSize: 15,
        padding: '12px 0',
    }),
    labelSpan: css({
        marginRight: 12,
        marginLeft: 12,
    }),
    filtersWrapper: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 0',
    }),
    filterItemLabel: css({
        fontSize: '13px',
        lineHeight: '13px',
        fontWeight: '400',
        color: '#000000',
    }),
    valuesWrapper: css({
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    }),
};
